const DEFAULT_LOCALE = "es-AR";
const DEFAULT_CURRENCY = "ARS";

export const MONEDA_APP = Object.freeze({
  locale: import.meta.env.VITE_APP_LOCALE || DEFAULT_LOCALE,
  currency: import.meta.env.VITE_APP_CURRENCY || DEFAULT_CURRENCY,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const formatter = new Intl.NumberFormat(MONEDA_APP.locale, {
  style: "currency",
  currency: MONEDA_APP.currency,
  minimumFractionDigits: MONEDA_APP.minimumFractionDigits,
  maximumFractionDigits: MONEDA_APP.maximumFractionDigits,
});

export const formatearMoneda = (value) => formatter.format(Number(value) || 0);

export const MONEDA_CERO_TEXTO = formatearMoneda(0);

export const monedaInputNumberProps = Object.freeze({
  mode: "currency",
  currency: MONEDA_APP.currency,
  locale: MONEDA_APP.locale,
  minFractionDigits: MONEDA_APP.minimumFractionDigits,
  maxFractionDigits: MONEDA_APP.maximumFractionDigits,
});
